export const FileProvider = {
  OsfStorage: 'osfstorage',
  GoogleDrive: 'googledrive',
  Box: 'box',
  DropBox: 'dropbox',
  OneDrive: 'onedrive',
  WebDav: 'webdav',
  S3: 's3',
  GitHub: 'github',
  Bitbucket: 'bitbucket',
  GitLab: 'gitlab',
  Figshare: 'figshare',
  Dataverse: 'dataverse',
  OwnCloud: 'owncloud',
  AzureBlobStorage: 'azureblobstorage',
};
